import React from 'react';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';

const About = () => {
    return (
        <>
            <div>
                <Navigation />

                {/* Hero Section */}
                <section className="relative mt-20 overflow-hidden bg-gradient-to-r from-brand-blue/80 to-brand-teal/60 text-white py-32">
                    <div className="blob bg-brand-green w-96 h-96 top-20 left-10"></div>
                    <div className="blob bg-brand-teal w-80 h-80 bottom-20 right-20" style={{ animationDelay: '2s' }}></div>

                    <div className="absolute inset-0">
                        <img src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=1920&h=600&fit=crop" alt="Team" className="w-full h-full object-cover opacity-20" />
                    </div>

                    <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
                        <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold mb-6 leading-tight">About VishwaVoyagerz</h1>
                        <p className="text-xl sm:text-2xl text-gray-200 max-w-3xl mx-auto">Creating unforgettable travel experiences since 2015. Your journey, our passion.</p>
                    </div>
                </section>

                {/* Our Story Section */}
                <section className="py-20 bg-white relative overflow-hidden">
                    <div className="absolute inset-0 opacity-5">
                        <div className="blob bg-brand-green w-96 h-96 top-20 right-20"></div>
                        <div className="blob bg-brand-teal w-80 h-80 bottom-20 left-20" style={{ animationDelay: '2s' }}></div>
                    </div>
                    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
                        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
                            <div className="hover-zoom rounded-2xl overflow-hidden shadow-2xl">
                                <img src="https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?w=800&h=600&fit=crop" alt="Our Story" className="w-full h-full object-cover transition duration-700" />
                            </div>
                            <div>
                                <h2 className="text-4xl sm:text-5xl font-bold text-gray-800 mb-6">Our Story</h2>
                                <p className="text-gray-600 mb-4 text-lg">Founded in 2015, VishwaVoyagerz began with a simple vision: to make world-class travel experiences accessible to everyone. What started as a small team of passionate travelers has grown into a thriving company serving clients across the globe.</p>
                                <p className="text-gray-600 mb-4 text-lg">Over the years, we've helped more than 50,00 travelers discover breathtaking destinations, immerse themselves in diverse cultures, and create memories that last a lifetime. Our commitment to excellence and personalized service has earned us numerous awards and the trust of thousands of satisfied customers.</p>
                                <p className="text-gray-600 text-lg">Today, we continue to innovate and expand our offerings, always keeping our clients' dreams and satisfaction at the heart of everything we do. Every journey we craft is a testament to our dedication to making travel extraordinary.</p>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Stats Section */}
                <section className="py-16 gradient-animate text-white relative overflow-hidden">
                    <div className="absolute inset-0 opacity-10">
                        <div className="blob bg-white w-96 h-96 top-0 left-0"></div>
                        <div className="blob bg-white w-80 h-80 bottom-0 right-0" style={{ animationDelay: '3s' }}></div>
                    </div>
                    
                </section>

                {/* Mission & Vision Section */}
                <section className="py-20 bg-gray-50 relative overflow-hidden">
                    <div className="absolute inset-0 opacity-5">
                        <div className="blob bg-brand-cyan w-96 h-96 top-40 left-40"></div>
                        <div className="blob bg-brand-green w-80 h-80 bottom-40 right-40" style={{ animationDelay: '3s' }}></div>
                    </div>
                    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
                        <div className="text-center mb-16">
                            <h2 className="text-4xl sm:text-5xl font-bold text-gray-800 mb-4">Our Mission & Vision</h2>
                            <p className="text-xl text-gray-600">Guiding principles that drive everything we do</p>
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                            <div className="bg-white rounded-2xl p-8 shadow-lg hover-lift card-shine">
                                <div className="w-20 h-20 bg-gradient-to-r from-brand-teal to-brand-cyan rounded-full flex items-center justify-center mb-6 float-animation">
                                    <i className="fas fa-bullseye text-4xl text-white"></i>
                                </div>
                                <h3 className="text-3xl font-bold text-gray-800 mb-4">Our Mission</h3>
                                <p className="text-gray-600 text-lg">To provide exceptional travel experiences that inspire, educate, and create lasting memories. We strive to make every journey seamless, safe, and unforgettable by combining expert knowledge with personalized service and attention to detail.</p>
                            </div>

                            <div className="bg-white rounded-2xl p-8 shadow-lg hover-lift card-shine">
                                <div className="w-20 h-20 bg-gradient-to-r from-brand-green to-brand-teal rounded-full flex items-center justify-center mb-6 float-animation-delayed">
                                    <i className="fas fa-eye text-4xl text-white"></i>
                                </div>
                                <h3 className="text-3xl font-bold text-gray-800 mb-4">Our Vision</h3>
                                <p className="text-gray-600 text-lg">To become the world's most trusted travel partner, connecting people with extraordinary destinations and cultures. We envision a future where travel is accessible, sustainable, and transformative for all, fostering global understanding and appreciation.</p>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Core Values Section */}
                <section className="py-20 bg-white relative overflow-hidden">
                    <div className="absolute inset-0 opacity-5">
                        <div className="blob bg-brand-green w-96 h-96 top-20 left-20"></div>
                        <div className="blob bg-brand-teal w-80 h-80 bottom-20 right-20" style={{ animationDelay: '4s' }}></div>
                    </div>
                    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
                        <div className="text-center mb-16">
                            <h2 className="text-4xl sm:text-5xl font-bold text-gray-800 mb-4">Our Core Values</h2>
                            <p className="text-xl text-gray-600">The principles that guide our every decision</p>
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                            <div className="bg-gradient-to-br from-green-50 to-teal-50 rounded-2xl p-8 shadow-lg hover-lift card-shine">
                                <div className="w-16 h-16 bg-brand-green rounded-full flex items-center justify-center mb-6">
                                    <i className="fas fa-heart text-3xl text-white"></i>
                                </div>
                                <h3 className="text-2xl font-bold text-gray-800 mb-3">Passion</h3>
                                <p className="text-gray-600">We love what we do and bring enthusiasm and dedication to every journey we create.</p>
                            </div>

                            <div className="bg-gradient-to-br from-cyan-50 to-blue-50 rounded-2xl p-8 shadow-lg hover-lift card-shine">
                                <div className="w-16 h-16 bg-brand-cyan rounded-full flex items-center justify-center mb-6">
                                    <i className="fas fa-handshake text-3xl text-white"></i>
                                </div>
                                <h3 className="text-2xl font-bold text-gray-800 mb-3">Integrity</h3>
                                <p className="text-gray-600">We build trust through transparency, honesty, and ethical business practices in all we do.</p>
                            </div>

                            <div className="bg-gradient-to-br from-green-50 to-emerald-50 rounded-2xl p-8 shadow-lg hover-lift card-shine">
                                <div className="w-16 h-16 bg-brand-teal rounded-full flex items-center justify-center mb-6">
                                    <i className="fas fa-star text-3xl text-white"></i>
                                </div>
                                <h3 className="text-2xl font-bold text-gray-800 mb-3">Excellence</h3>
                                <p className="text-gray-600">We strive for the highest quality in every aspect, never settling for anything less than exceptional.</p>
                            </div>

                            <div className="bg-gradient-to-br from-teal-50 to-cyan-50 rounded-2xl p-8 shadow-lg hover-lift card-shine">
                                <div className="w-16 h-16 bg-brand-teal rounded-full flex items-center justify-center mb-6">
                                    <i className="fas fa-lightbulb text-3xl text-white"></i>
                                </div>
                                <h3 className="text-2xl font-bold text-gray-800 mb-3">Innovation</h3>
                                <p className="text-gray-600">We constantly push boundaries and embrace new ideas to deliver cutting-edge travel experiences.</p>
                            </div>

                            <div className="bg-gradient-to-br from-blue-50 to-cyan-50 rounded-2xl p-8 shadow-lg hover-lift card-shine">
                                <div className="w-16 h-16 bg-brand-blue rounded-full flex items-center justify-center mb-6">
                                    <i className="fas fa-users text-3xl text-white"></i>
                                </div>
                                <h3 className="text-2xl font-bold text-gray-800 mb-3">Collaboration</h3>
                                <p className="text-gray-600">We believe in the power of teamwork and work closely with clients to achieve shared goals.</p>
                            </div>

                            <div className="bg-gradient-to-br from-green-50 to-teal-50 rounded-2xl p-8 shadow-lg hover-lift card-shine">
                                <div className="w-16 h-16 bg-brand-green rounded-full flex items-center justify-center mb-6">
                                    <i className="fas fa-leaf text-3xl text-white"></i>
                                </div>
                                <h3 className="text-2xl font-bold text-gray-800 mb-3">Sustainability</h3>
                                <p className="text-gray-600">We're committed to responsible tourism that protects our planet for future generations.</p>
                            </div>
                        </div>
                    </div>
                </section>

             

                {/* Why Choose Us Section */}
                <section className="py-20 gradient-animate text-white relative overflow-hidden">
                    <div className="absolute inset-0 opacity-10">
                        <div className="blob bg-white w-96 h-96 top-20 left-20"></div>
                        <div className="blob bg-white w-80 h-80 bottom-20 right-20" style={{ animationDelay: '3s' }}></div>
                    </div>
                    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
                        <div className="text-center mb-16">
                            <h2 className="text-4xl sm:text-5xl font-bold mb-4">Why Choose VishwaVoyagerz?</h2>
                            <p className="text-xl text-green-100">Your trusted partner for unforgettable travel experiences</p>
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
                            <div className="text-center transform hover:scale-110 transition duration-300">
                                <div className="bg-white/10 backdrop-blur-lg w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6 float-animation">
                                    <i className="fas fa-shield-alt text-4xl"></i>
                                </div>
                                <h3 className="text-2xl font-bold mb-3">Safe & Secure</h3>
                                <p className="text-green-100">Your safety is our priority with 24/7 support and comprehensive travel insurance</p>
                            </div>

                            <div className="text-center transform hover:scale-110 transition duration-300">
                                <div className="bg-white/10 backdrop-blur-lg w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6 float-animation-delayed">
                                    <i className="fas fa-award text-4xl"></i>
                                </div>
                                <h3 className="text-2xl font-bold mb-3">Award Winning</h3>
                                <p className="text-green-100">Recognized globally for excellence in travel services and customer satisfaction</p>
                            </div>

                            <div className="text-center transform hover:scale-110 transition duration-300">
                                <div className="bg-white/10 backdrop-blur-lg w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6 float-animation">
                                    <i className="fas fa-dollar-sign text-4xl"></i>
                                </div>
                                <h3 className="text-2xl font-bold mb-3">Best Prices</h3>
                                <p className="text-green-100">Competitive rates with no hidden fees and flexible payment options available</p>
                            </div>

                            <div className="text-center transform hover:scale-110 transition duration-300">
                                <div className="bg-white/10 backdrop-blur-lg w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6 float-animation-delayed">
                                    <i className="fas fa-headset text-4xl"></i>
                                </div>
                                <h3 className="text-2xl font-bold mb-3">24/7 Support</h3>
                                <p className="text-green-100">Round-the-clock customer service to assist you before, during, and after your trip</p>
                            </div>
                        </div>
                    </div>
                </section>

                {/* CTA Section */}
                <section className="py-20 bg-gradient-to-r from-brand-teal to-brand-cyan relative overflow-hidden">
                    <div className="absolute inset-0 opacity-10">
                        <div className="blob bg-white w-96 h-96 top-20 right-20"></div>
                        <div className="blob bg-white w-80 h-80 bottom-20 left-20" style={{ animationDelay: '2s' }}></div>
                    </div>
                    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
                        <h2 className="text-4xl sm:text-5xl font-bold text-white mb-6">Ready to Start Your Adventure?</h2>
                        <p className="text-xl text-green-100 mb-8">Let's discuss how we can help transform your travel dreams into reality with our expertly curated experiences.</p>
                        <div className="flex flex-col sm:flex-row gap-4 justify-center">
                            <a href="index.html#packages" className="bg-white text-brand-teal px-8 py-4 rounded-full font-semibold hover:bg-gray-100 transition transform hover:scale-110 hover:shadow-xl">
                                <i className="fas fa-search mr-2"></i>Explore Tours
                            </a>
                            <a href="index.html#contact" className="border-2 border-white text-white px-8 py-4 rounded-full font-semibold hover:bg-white hover:text-brand-teal transition transform hover:scale-110">
                                <i className="fas fa-envelope mr-2"></i>Contact Us
                            </a>
                        </div>
                    </div>
                </section>

                <Footer />



            </div>
        </>
    );
};

export default About;
